module.exports = __webpack_public_path__ + "static/media/icon_summary_segments.45221c76.svg";